import { format } from 'date-fns'
import './ugly-cancellations-popup.css'
const UglyCancellationsPopup = ({cancellations, setShowPopup}) => {
    return (
        <div className='ugly-cancellations-popup'>
            <div className='ugly-cancellations-popup__x' onClick={() => setShowPopup(null)}>x</div>
            {cancellations.map(cancellation => (
                <div className='ugly-cancellations__each-cancellation'>{cancellation.studentName} {cancellation.familyName} | {format(new Date(cancellation.dateTime), 'MM/dd')}: {cancellation.reason}</div>
            ))}
        </div>
    )
}
export default UglyCancellationsPopup